// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__KJAwK","modal":"Modal_modal__EX4d8","slide-down":"Modal_slide-down__WEzPq"};